<template>
  <form class="form-group-wrap" v-on:submit.prevent>
    <slot v-bind="customRules()"></slot>
  </form>
</template>
<script>
 /* eslint-disable */ 
export default {
  data() {
    return {
      slots: [],
    };
  },
  props: {
    customValidation: {
      type: Object,
      default: function () {
        return {
          hide: {},
          validate: {},
          disabled: {},
        };
      },
    },
  },
  methods: {
    customRules() {
      return {
        hide: this.customValidation.hide || {},
        validate: this.customValidation.validate || {},
        disabled: this.customValidation.disabled || {},
      };
    },
  },
  created() {
    this.slots = this.$children;
  },
};
</script>

<style lang="scss">
@import "./scss/styles.scss";
</style>
